document.addEventListener( 'wpcf7mailsent', function( event ) {
    try {

        const target = event.target as any;

        const formFieldsEl = jQuery(target).find('.form-fields');

        if (formFieldsEl){
            formFieldsEl.addClass('d-none');
        }

        const msgEl = document.getElementsByClassName('wpcf7-response-output');

        if (msgEl.length){
            setTimeout(function(){
                msgEl[0].scrollIntoView();
            }, 100);
        }

    } catch (error){
        console.error(error);
    }
});